
<div class="dialog-title" *ngIf="result?.title">
  {{ result.title }}
</div>

<div class="dialog-description" *ngIf="result?.content">
  {{ result.content }}
</div>


<div class="value-container">
  <div class="content-wrapper full">
    <div class="label-f" *ngIf="result.labelTitle">{{result.labelTitle}}</div>
    <div class="value-f"  *ngIf="result.labelName">{{result.labelName}}</div>
  </div>
</div>


<div *ngIf="result.showTextBox">
  <mat-form-field class="example-full-width">
    <input
      matInput
      placeholder="{{ result.placeholder }}"
      [(ngModel)]="txtValue"
      name="txt"
      required
    />
    <mat-error>{{ result.placeholder }} is required</mat-error>
  </mat-form-field>
</div>

<div *ngIf="result?.showDate">
  <mat-form-field fxFlex="50" class="left">
    <mat-label>Start Date</mat-label>
    <input matInput [matDatepicker]="start" (click)="start.open()" required [(ngModel)]="startDate"/>
    <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
    <mat-datepicker #start></mat-datepicker>
    <mat-error>Start Date is required</mat-error>
  </mat-form-field>

  <mat-form-field fxFlex="50" class="right">
    <mat-label>End Date</mat-label>
    <input matInput [matDatepicker]="end" (click)="end.open()" required [(ngModel)]="endDate"/>
    <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
    <mat-datepicker #end></mat-datepicker>
    <mat-error>End Date is required</mat-error>
  </mat-form-field>

</div>

<div class="dialog-buttons no-divider">
  <button
    mat-button
    color="primary"
    [mat-dialog-close]="false"
    (click)="close()"
    *ngIf="!result.hideNoBtn"
  >
    {{ result.no }}
  </button>
  <button
    mat-button
    color="primary"
    cdkFocusInitial
    [mat-dialog-close]="true"
    *ngIf="!result.showTextBox && !result.hideYesBtn"
  >
    {{ result.yes }}
  </button>
  <button
    mat-button
    color="primary"
    (click)="save()"
    *ngIf="result.showTextBox && !result.hideYesBtn "
  >
    {{ result.yes }}
  </button>
</div>